/* eslint-disable @typescript-eslint/no-unused-vars */
import { Flex, Menu } from '@chakra-ui/react'
import { BsThreeDotsVertical } from 'react-icons/bs'
import { FaEdit, FaEllipsisV, FaTrash } from 'react-icons/fa'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { StyledMenuButton } from '../../../../components/NavBar/Components/StyledMenuButton'
import { StyledMenuItem } from '../../../../components/NavBar/Components/StyledMenuItem'
import { StyledMenuList } from '../../../../components/NavBar/Components/StyledMenuList'
import { useFormulario } from '../../../../contexts/FormularioContext'
import { iCompetencia } from '../../../../interfaces'
import { ImgText, Container, DropMenu } from './styles'

interface CardProps {
  Competencia: iCompetencia
  onClickPreVisualizar: () => void
}

export const CardCompetencia: React.FC<CardProps> = ({ onClickPreVisualizar, Competencia }) => {
  return (
    <Container border={'v2'}>
      <ImgText>
        <img src={Competencia.icone}/>
        <span>{Competencia.nome.replace('/', ' / ')}</span>
      </ImgText>
      <Flex flexDir={'column'} gap={'.325rem'} marginTop={'.325rem'} >
        <ButtonCmp OutlineColor={'Rosa'} h={'1.25rem'} fontSize={'.65rem'} size={'xs'} onClick={() => onClickPreVisualizar()}>Visualizar questões</ButtonCmp>
      </Flex>
    </Container>
  )
}
